import { type CustomerStatusDataGridRow } from "../types";
import { type AxiosInstance, HttpStatusCode, isAxiosError } from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";

export const GetCustomerListAPI = async (
  apiClient: AxiosInstance,
  url: string,
  cities: string[],
  prefectures: string[],
  realEstateTypes: string[]
): Promise<CustomerStatusDataGridRow[]> => {
  const response = await apiClient
    .post<CustomerStatusDataGridRow[]>(url, {
      body: {
        cities,
        prefectures,
        realEstateTypes,
        isEmailFilter: false,
      },
    })
    .catch((error): void => {
      if (
        isAxiosError(error) &&
        (error.response?.status ?? HttpStatusCode.InternalServerError) >=
          HttpStatusCode.InternalServerError
      ) {
        SendToTrackingService(error);
      }
      return undefined;
    });

  if (response) {
    return response.status === HttpStatusCode.Ok ? response.data : [];
  }
  return [];
};
